import type { IAggregatedEvent } from "~/types/event";
import { getEventEndDate } from "~/utils/getEventEndDate";

export interface IEventResolution {
  isResolved: boolean;
  date: string | null;
}

export const getEventResolution = (
  event: IAggregatedEvent
): IEventResolution => {
  const expectedEndDate = getEventEndDate(event);

  if (event.resolved) {
    return {
      isResolved: true,
      date: event.resolutionData?.resolvedAt ?? expectedEndDate,
    };
  }

  return { isResolved: false, date: expectedEndDate };
};
